import dryer from '../components/subcomponents/infoDrawer/dryer';
import laundryAccessory from '../components/subcomponents/infoDrawer/laundry-accessory';
import washer from '../components/subcomponents/infoDrawer/washer';
import {
  EXPERIENCE_TYPE_KITCHEN, EXPERIENCE_TYPE_LAUNDRY,
  DRYER_FUEL_TYPE, LAUNDRY_ACCESSORIES_DRAWER, WASHER_TYPE, KITCHEN_FUEL_TYPE,
  WASHER, DRYER, GAS, ELECTRIC, AGITATORS, IMPELLER, RANGE
} from '../constants/index';

export const compareString = (firstString, secondString) => {
  return firstString?.toLowerCase() === secondString?.toLowerCase();
};

const isStringIncludes = (sourceString, patternString) => {
  return sourceString?.toLowerCase()?.includes(patternString?.toLowerCase());
};

export const getSelectableVariantType = (product, variantName) => {
  const features = product?.keyProductFeatures?.keyProductFeaturesItems?.[0]?.features;
  if (!Array.isArray(features) || features.length === 0) {
    return null;
  }
  const featureType = features?.find((feature) => compareString(feature?.name, variantName));

  if (featureType?.value) {
    return featureType?.value;
  }

  return null;
};

export const getSelectableVariantFromTitle = (product, variantName) => {
  const title = product?.identifiers?.productLabel;
  switch (variantName) {
  case KITCHEN_FUEL_TYPE:
    if (isStringIncludes(title, ELECTRIC) || isStringIncludes(title, 'induction')) {
      return ELECTRIC;
    }
    if (isStringIncludes(title, GAS)) {
      return GAS;
    }
    return null;
  case WASHER_TYPE:
    if (isStringIncludes(title, AGITATORS)) {
      return AGITATORS;
    }
    if (isStringIncludes(title, IMPELLER)) {
      return IMPELLER;
    }
    return null;
  case DRYER_FUEL_TYPE:
    if (isStringIncludes(title, GAS)) {
      return GAS;
    }
    if (isStringIncludes(title, ELECTRIC)) {
      return ELECTRIC;
    }
    return null;
  default:
    return null;
  }
};

export const getSelectableVariants = (selectableVariants, variantName) => {

  const variants = Array.from(
    new Set(selectableVariants)
  )?.filter((variant) => compareString(variant?.name, variantName));

  if (!variants?.length) return null;

  return variants;
};

export const getApplianceType = (product) => {
  const applianceType = product?.identifiers?.applianceType || '';
  return applianceType;
};

export const getVariantName = (experienceType, product) => {
  const applianceType = getApplianceType(product);
  switch (experienceType) {
  case EXPERIENCE_TYPE_KITCHEN:
    return KITCHEN_FUEL_TYPE;
  case EXPERIENCE_TYPE_LAUNDRY:
    if (compareString(applianceType, WASHER)) { return WASHER_TYPE; }
    if (compareString(applianceType, DRYER)) { return DRYER_FUEL_TYPE; }
    return '';
  default:
    return '';
  }
};

export const getDrawerInfo = (variantName) => {
  switch (variantName) {
  case DRYER_FUEL_TYPE:
    return dryer;
  case LAUNDRY_ACCESSORIES_DRAWER:
    return laundryAccessory;
  case WASHER_TYPE:
    return washer;
  default:
    return {};
  }
};

export const getVariantGroup = (selectableVariantsData, position = 0) => {
  const variantGroup = Object.entries(selectableVariantsData || {})?.[position] || [];
  const [variantName, variants] = variantGroup;

  return { variantName, variants };
};

export const isProductInVariantGroup = ({ productId, variants }) => {
  if (!productId || !variants) return false;
  return variants?.some((variant) => variant?.id === productId);
};

const textOnlyFuelTypeAppliance = (product) => {
  const applianceType = getApplianceType(product);
  return compareString(applianceType, RANGE) || compareString(applianceType, DRYER);
};

export const getTextOnlyFuelType = (product, variantName, selectableVariants) => {
  const isValidFuelTypeAppliance = textOnlyFuelTypeAppliance(product);
  if (!product || !variantName || !selectableVariants || !isValidFuelTypeAppliance) return null;

  const variants = selectableVariants?.[variantName] || [];
  const matchingVariant = variants?.find((variant) => variant?.id === product?.itemId);

  if (variants?.length > 1 && matchingVariant) return null;

  return matchingVariant?.value
    || getSelectableVariantType(product, variantName)
    || getSelectableVariantFromTitle(product, variantName);
};
